module.exports = __webpack_public_path__ + "static/media/Доклад на ДВИ.6166340d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2020/Доклад на ДВИ.pdf
// module id = 112
// module chunks = 0